import { Component, Input, OnInit } from '@angular/core';
import { PlPiClientCardService } from '../../services/pl-pi-client-card.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CardDeliveryAddressResponse } from '../../api/client.card';
import { take } from 'rxjs/operators';
import { AMOUNT, ID, STRING, TransformInstructions, TransformInstructionsBuilder } from '@backoffice-monorepo/commons';

@Component({
  selector: 'backoffice-monorepo-pl-pi-client-card-address',
  templateUrl: './pl-pi-client-card-address.component.html',
  styleUrls: ['./pl-pi-client-card-address.component.scss']
})
export class PlPiClientCardAddressComponent implements OnInit {

  @Input() cardId: number;
  deliveryAddress: CardDeliveryAddressResponse;

  constructor(
    public activeModal: NgbActiveModal,
    private clientCardService: PlPiClientCardService,
  ) { }

  cardDeliveryAddressTransformations: TransformInstructions = TransformInstructionsBuilder.build(
    [
      ['postalCode', ['Postal code', STRING]],
      ['houseNumber', ['House number', STRING]],
      ['province', ['Province', STRING]],
      ['street', ['Street', STRING]],
      ['apartmentNumber', ['Apartment number', STRING]],
    ]
  );

  ngOnInit(): void {
    this.clientCardService.getCardDeliveryAddress(this.cardId).pipe(take(1)).subscribe(
      response => {
        this.deliveryAddress = response;
      }
    )
  }

}
